import {
  createSelector
} from 'reselect'

const namespace = 'taskHall'

export const getState = state => state[namespace]

export const getConvIdsSelector = createSelector(
  getState,
  state => {
    return state
      .get('unpinned')
      .concat(state.get('pinned'))
      .reverse()
  }
)



export const firstConvSelector = createSelector(
  getConvIdsSelector,
  convIds => convIds.first()
)

export const taskRefreshKeySelector = createSelector(
  getState,
  state => {
    return state.get('taskRefreshKey')
  }
)
export const chaoshiRefreshKeySelector = createSelector(
  getState,
  state => {
    return state.get('chaoshiRefreshKey')
  }
)
export const orderUpdateRefreshKeySelector = createSelector(
  getState,
  state => {
    return state.get('orderUpdateRefreshKey')
  }
)
